import React from "react";
import { STRING_TIPO_DE_IMAGEN } from "../../utils/const/string-const";
import ImageTypeSelector from "./ImageTypeSelector";
import SingleRasterImageUpload from "./SingleRasterImageUpload";
import SingleSvgUpload from "./SingleSvgUpload";

export default function ProductMainImageSection({
    tipoImagenPrincipal,
    imagenPrincipal,
    onTipoChange,
    onImagenChange,
    t,
    disabled = false,
    onBusyChange,
    onError,
}) {
    const selectedTipo = tipoImagenPrincipal || STRING_TIPO_DE_IMAGEN.image;

    const handleTipoChange = (nextTipo) => {
        if (nextTipo !== selectedTipo) {
            onImagenChange("");
        }
        onTipoChange(nextTipo);
    };

    return (
        <section className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-5">
            <h3 className="text-base font-bold text-slate-900 mb-4">{t("label_imagen_principal")}</h3>

            <ImageTypeSelector
                label={t("label_tipo_imagen_principal")}
                value={selectedTipo}
                onChange={handleTipoChange}
                t={t}
                disabled={disabled}
            />

            <div className="mt-4">
                {selectedTipo === STRING_TIPO_DE_IMAGEN.image && (
                    <SingleRasterImageUpload
                        value={imagenPrincipal}
                        onChange={onImagenChange}
                        t={t}
                        disabled={disabled}
                        onBusyChange={onBusyChange}
                        onError={onError}
                    />
                )}

                {selectedTipo === STRING_TIPO_DE_IMAGEN.svg && (
                    <SingleSvgUpload
                        value={imagenPrincipal}
                        onChange={onImagenChange}
                        t={t}
                        disabled={disabled}
                        onError={onError}
                    />
                )}
            </div>
        </section>
    );
}
